var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMental(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2 Copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing---Web-Copy-6",
    transform: "translate(-792.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-5",
    transform: "translate(792.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.195652,109.478261 C132.105402,109.478261 147.434783,94.14888 147.434783,75.2391304 C147.434783,56.3293808 132.105402,41 113.195652,41 C94.2859026,41 78.9565217,56.3293808 78.9565217,75.2391304 C78.9565217,79.9105719 78.9565217,93.4975284 78.9565217,116 L92,109.478261 C102.069735,109.478261 109.134952,109.478261 113.195652,109.478261 Z",
    id: "Oval",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9795491,106.109409 L51,87.5 L51,87.5 C47.6666667,82.6686199 46,79.0019533 46,76.5 C46,40.5 75.4135361,23.9995838 96.5,23.9995838 C131.5,23.9995838 151,44 156.5,59 C162,74 159.058273,99.1200949 147,107 C133.232318,115.996979 148.628405,134.673468 138.5,137.5 C125.158142,141.223309 112.971536,152.888981 101.940183,172.497014 L101.940182,172.497013 C101.398586,173.45969 100.179133,173.801044 99.2164562,173.259448 C98.7477635,172.995764 98.4050083,172.554441 98.2655364,172.035067 C95.0651037,160.117097 90.9765915,151.772074 86,147 C77.538405,138.886142 60.5474225,153.82268 54.5,140 C52.1666667,134.666667 51,125.5 51,112.5 L41.3960132,107.46934 C40.9067819,107.213076 40.7179246,106.608733 40.9741886,106.119502 C40.9759562,106.116127 40.977743,106.112763 40.9795491,106.109409 Z",
    id: "Path-5",
    stroke: "#000000",
    strokeWidth: 4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMental);
export default __webpack_public_path__ + "static/media/mental.158d7c6895145beda233a96ba6fa20be.svg";
export { ForwardRef as ReactComponent };